import { createElement } from "react";
import { Link } from "react-router-dom";
import { SignOutButton } from "@/components/sign-out-button";
import { useAuth } from "@/lib/auth";
export function MarketingAuthNav() {
  const { user, status } = useAuth();
  const signedIn = status === "authenticated" && Boolean(user);
  if (status === "loading") {
    return <div className="flex min-h-10 min-w-[9rem] items-center justify-end"><span className="sr-only">Checking sign-in…</span></div>;
  }
  if (signedIn) {
    return (
      <div className="flex items-center gap-2">
        <Link to="/dashboard" className="rounded-full bg-teal-700 px-4 py-2.5 text-sm font-semibold text-white shadow-md shadow-teal-700/20 hover:bg-teal-800">Open app</Link>
        <SignOutButton label="Sign out" className="hidden rounded-full px-3 py-2 text-sm font-semibold text-slate-700 hover:bg-white/70 sm:inline-flex" />
      </div>
    );
  }
  // Signed out: the shared Wannlabs "Sign up free" + "Log in" pair (<wl-auth-cta>, wannlabs.com/assets/wl-growth.js),
  // pointed at Prime's own sign-up and sign-in. Both stay visible on phones. The links below show until it loads.
  return (
    <div className="wl-cta-host flex items-center gap-2">
      {createElement("wl-auth-cta", { "signed-in": "false", theme: "light", "signup-href": "/signup", "login-href": "/login", "data-testid": "auth-cta" })}
      <span className="wl-cta-fallback flex items-center gap-2">
        <Link to="/login" className="inline-flex min-h-10 items-center rounded-full border border-slate-300 px-3 py-2 text-sm font-semibold text-slate-800 hover:bg-white/70">Log in</Link>
        <Link to="/signup" className="inline-flex min-h-10 items-center rounded-full bg-teal-700 px-4 py-2.5 text-sm font-semibold text-white shadow-md shadow-teal-700/20 hover:bg-teal-800">Sign up free</Link>
      </span>
    </div>
  );
}
